<template>
  <div class="app-container">
    <el-autocomplete v-model="mapLocation.address" :fetch-suggestions="querySearch" placeholder="地址" style="width: 40%" :trigger-on-focus="false" @select="handleSelect"/>
    <div style="margin: 5px">
      <baidu-map class="bm-view" :center="mapCenter" :zoom="mapZoom" :scroll-wheel-zoom="true" ak="baidu-ak" @ready="handlerBMap" />
    </div>
  </div>
</template>
<script type="text/javascript" src="http://api.map.baidu.com/api?v=2.0&ak=nSxiPohfziUaCuONe4ViUP2N"></script>
<script>
import BaiduMap from "vue-baidu-map/components/map/Map.vue";
export default {
  name: "BaiduMapDemo",
  components: {
    BaiduMap
  },

  data() {
    return {
      mapZoom: 15,
      mapCenter: { lng: 0, lat: 0 },
      mapLocation: {
        address: undefined,
        coordinate: undefined
      }
    };
  },
  created() {
    // this.queryCenterAdress();
    this.getAreaId()
  },
  methods: {
    handlerBMap({ BMap, map }) {
      this.BMap = BMap;
      this.map = map;
      if (this.mapLocation.coordinate && this.mapLocation.coordinate.lng) {
        this.mapCenter.lng = this.mapLocation.coordinate.lng;
        this.mapCenter.lat = this.mapLocation.coordinate.lat;
        this.mapZoom = 15;
        map.addOverlay(new this.BMap.Marker(this.mapLocation.coordinate));
      } else {
        this.mapCenter.lng = 113.633141;
        this.mapCenter.lat = 34.752965;
        this.mapZoom = 15;
      }
      var vm = this;
      this.map.addEventListener("click", function(e) {
        //点击地图事件，获取经纬度

        vm.map.clearOverlays();
        var pt = e.point;
        var marker = new BMap.Marker(pt);
        vm.map.addOverlay(marker);

        var geoc = new BMap.Geocoder();
        geoc.getLocation(pt, function(rs) {
          var addComp = rs.addressComponents;
          //将得到的位置赋值给中心位置
          vm.mapLocation.address =
            addComp.province +
            addComp.city +
            addComp.district +
            addComp.town +
            addComp.street +
            addComp.streetNumber;
          vm.$emit("backParent", vm.mapLocation.address); //子组件往父组件传值
          vm.$emit("coordinate", vm.mapCenter.lng + "," + vm.mapCenter.lat); //子组件往父组件传值
        });
      });
    },
    querySearch(queryString, cb) {
      var that = this;
      var myGeo = new this.BMap.Geocoder();
      myGeo.getPoint(
        queryString,
        function(point) {
          if (point) {
            that.mapLocation.coordinate = point;
            that.makerCenter(point);
          } else {
            that.mapLocation.coordinate = null;
          }
        },
        this.locationCity
      );
      var options = {
        onSearchComplete: function(results) {
          if (local.getStatus() === 0) {
            // 判断状态是否正确
            var s = [];
            for (var i = 0; i < results.getCurrentNumPois(); i++) {
              var x = results.getPoi(i);
              var item = { value: x.address, point: x.point };
              s.push(item);
              cb(s);
            }
          } else {
            cb();
          }
        }
      };
      var local = new BMap.LocalSearch(this.map, options);
      local.search(queryString);
    },
    handleSelect(item) {
      var { point } = item;
      this.mapLocation.coordinate = point;
      this.makerCenter(point);
      this.$emit("backParent", this.mapLocation.address); //子组件往父组件传值
    },
    makerCenter(point) {
      if (this.map) {
        this.map.clearOverlays();
        this.map.addOverlay(new this.BMap.Marker(point));
        this.mapCenter.lng = point.lng;
        this.mapCenter.lat = point.lat;
        this.$emit("coordinate", this.mapCenter.lng + "," + this.mapCenter.lat); //子组件往父组件传值
        this.mapZoom = 15;
      }
    },
     async getAreaId() {
      const {
        code,
        msg,
        data
      } = await this.request.get("/front/system/config/query")
      if (code !== 200) {
        if(code==500){
          return this.$message.error(msg)
        }
        return
      }
      let systemNameItem = data.find(item=>item.code=="SYS_NAME")
      this.systemName = systemNameItem.value
      let areaItem = data.find(item => item.type == 3)
      let areaId = areaItem.value.split('_')
      let curId = null
      if (areaId.length == 1) {
        curId = areaId[0]
      } else if (areaId.length == 2) {
        curId = areaId[1]
      }
      this.getPosition(curId)
    },
    async getPosition(curId) {
      const {
        code,
        msg,
        data
      } = await this.request.get(`/front/region/queryRegionById?regionId=${curId}`)
      if (code !== 200) {
        if(code==500){
          return this.$message.error(msg)
        }
        return
      } else {
         this.mapLocation.coordinate =data.longitude+","+data.latitude
           var array = this.mapLocation.coordinate.split(",");
                  var new_point = new BMap.Point(array[0], array[1]);
                  var marker = new BMap.Marker(new_point);
                  this.map.addOverlay(marker);
                  this.map.panTo(new_point);
                  this.map.centerAndZoom(new_point, 10);
                  this.mapLocation.address =data.province+(data.city?data.city:'')
                  this.$emit("coordinate",array.join(","))
                  console.log(`data`, data)
                  console.log(`data.province`, data.province)
                  // var new_point = new BMap.Point(113.633141,34.752965)
              /*     var new_point = new BMap.Point(34.7566109,34.752965)
                   var marker = new BMap.Marker(new_point);
                  this.map.addOverlay(marker);
                  this.map.panTo(new_point);
                  console.log(`new_point`, new_point)
                  this.map.centerAndZoom(new_point, 10);
                  this.mapLocation.address = data.province */
      }
    },
  /*   queryCenterAdress() {
      this.axios.get("/front/config/query").then(data => {
        if (data.code == 200) {
          // this.platformName = data.data[0].children[0].value
          if (data.data.length > 0) {
            for (var i = 0; i < data.data.length; i++) {
              for (var j = 0; j < data.data[i].children.length; j++) {
                if (data.data[i].children[j].code == "map_coordinate") {
                  this.mapLocation.coordinate = data.data[i].children[j].value;
                  var array = this.mapLocation.coordinate.split(",");
                  var new_point = new BMap.Point(array[0], array[1]);
                  var marker = new BMap.Marker(new_point);
                  this.map.addOverlay(marker);
                  this.map.panTo(new_point);
                  this.map.centerAndZoom(new_point, 15);
                } else if (data.data[i].children[j].code == "map_location") {
                  this.mapLocation.address = data.data[i].children[j].value;
                }
              }
            }
          }
        }
      });
    } */
  }
};
</script>

<style>
.bm-view {
  width: 100%;
  height: 300px;
}
</style>